import React from 'react';
import { Skeleton } from '@strivelabs/ui-core';

export const InsightsCardSkeleton: React.FC = () => (
  <div className="w-full rounded-lg border border-border bg-card p-4 md:p-6">
    <div className="mb-4 space-y-2">
      <Skeleton className="h-5 w-40" />
      <Skeleton className="h-3 w-64" />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
      <Skeleton className="h-40 md:h-48 w-full" />
      <div className="flex flex-col justify-between gap-4">
        <div className="space-y-2">
          <Skeleton className="h-3 w-5/6" />
          <Skeleton className="h-3 w-4/6" />
          <Skeleton className="h-3 w-3/6" />
        </div>
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-28" />
        </div>
      </div>
    </div>
  </div>
);
